export { default, withSentryErrorBoundary } from "./SentryErrorBoundary";
